import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import './styles.sass';

/**
 * Simple error label to be used on white surfaces.
 */
var ErrorLabel = function ErrorLabel(_ref) {
  var children = _ref.children;
  return children ? /*#__PURE__*/React.createElement("div", {
    className: "ErrorLabel"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "exclamation"
  }), children) : null;
};
ErrorLabel.propTypes = {
  children: PropTypes.node
};
export default ErrorLabel;
//# sourceMappingURL=index.js.map
